import { render, staticRenderFns } from "./NavHeaders.vue?vue&type=template&id=97accde6&scoped=true"
import script from "./NavHeaders.vue?vue&type=script&lang=js"
export * from "./NavHeaders.vue?vue&type=script&lang=js"
import style0 from "./NavHeaders.vue?vue&type=style&index=0&id=97accde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97accde6",
  null
  
)

export default component.exports